import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { NSRateConstants } from '@ruby/configs/rate-inquiry.constants';
import { IRateInquiryItem, IRateSearch } from '@ruby/modules/rate-inquiry/models/rate-inquiry.interface';
import { ICarType } from '@ruby/shared/models/rate-inquiry/cartype.interface';

@Component({
  selector: 'ng-rate-list',
  templateUrl: './rate-list.component.html',
  styleUrls: ['./rate-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RateListComponent implements OnChanges {
  @Input() loading!: boolean;
  @Input() searchList!: Array<IRateSearch>;
  @Input() displayList!: boolean;
  @Input() rateInquiryItem?: IRateInquiryItem;
  @Output() editItem = new EventEmitter<IRateInquiryItem>();
  @Output() search = new EventEmitter<Array<IRateSearch>>();
  @Output() updateLayout = new EventEmitter<boolean>();
  @Output() setInquiryList = new EventEmitter<number>();
  @Output() clearItem = new EventEmitter(true);
  @Output() addRateSearchItem = new EventEmitter<IRateSearch>(true);
  @Output() setRateSearchList = new EventEmitter<Array<IRateSearch>>();
  @Output() clearRateSearchList = new EventEmitter();
  @Output() setCarTypes = new EventEmitter<ICarType>();
  panelOpenState = false;
  headerList: Array<string> = NSRateConstants.headerList;
  maxQueries = NSRateConstants.maxQueries;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.rateInquiryItem && changes.rateInquiryItem.currentValue && isNaN(changes.rateInquiryItem.currentValue.index)) {
      this.addRateSearchItem.emit(changes.rateInquiryItem.currentValue.data);
    }

    if (changes.rateInquiryItem && changes.rateInquiryItem.currentValue && changes.rateInquiryItem.currentValue.isEdit) {
      const rateSearchList = [...this.searchList];
      rateSearchList.splice(changes.rateInquiryItem.currentValue.index, 1, changes.rateInquiryItem.currentValue.data);
      this.setRateSearchList.emit(rateSearchList);
      this.clearItem.emit();
    }
  }

  /**
   * Delete
   *
   * @summary Called to delete a row from the list
   * @params index: number
   * @returns void
   */
  delete(index: number): void {
    const rateSearchList = [...this.searchList];
    const updatedRateSearchList = rateSearchList.filter((val, i) => i !== index);
    this.setRateSearchList.emit(updatedRateSearchList);
    this.setInquiryList.emit(updatedRateSearchList.length);
  }

  /**
   * Clone
   *
   * @summary Called to clone a row from the list
   * @params $data: IRateSearch
   * @returns void
   */
  clone($data: IRateSearch): void {
    const rateSearchList = [...this.searchList];
    this.addRateSearchItem.emit($data);
    this.setInquiryList.emit(rateSearchList.length + 1);
  }

  /**
   * Edit
   *
   * @summary Edit & load a row data from the list
   * @params $data: IRateSearch
   * @params $index: number
   * @returns void
   */
  edit($data: IRateSearch, $index: number): void {
    if ($data.carType.key.carTypeCode !== NSRateConstants.defaultCarType.key.carTypeCode) {
      this.setCarTypes.emit($data.carType);
    }
    this.editItem.emit({ data: $data, index: $index });
  }

  /**
   * Search Inquiry
   *
   * @summary Search for Rate Inquiry
   * @returns void
   */
  searchInquiry(): void {
    this.search.emit(this.searchList);
    this.updateLayout.emit(false);
  }

  /**
   * Clear List
   *
   * @summary Clear the search list
   * @returns void
   */
  clearList(): void {
    this.clearRateSearchList.emit();
    this.updateLayout.emit(true);
  }
}
